/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import ReactDOMServer from "react-dom/server";

import ReactToPrint from "react-to-print";
// import prettier from "prettier";

import { API, graphqlOperation } from "aws-amplify";
import { serviceByAccountByStatusByName } from "../../../graphql/queries";

import {
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  makeStyles,
  Switch,
  TextField as InputField,
  Typography,
} from "@material-ui/core";

import {
  Button,
  Loading,
  Show,
  SimpleShowLayout,
  TopToolbar,
  useNotify,
  useShowController,
} from "react-admin";

import { logError } from "../../../utils/appUtils";
import { REGEX_MULTI_EMAIL, ServiceStatus } from "../../../utils/constants";
import { getBackPath, splitEmails, trimEmail } from "../../../utils/utils";

import { CancelIcon, EmailIcon, PrintIcon } from "../../../components/common/iconography";
import { BackButton } from "../../../components/common/BackButton";
import { EmailInvoiceBody } from "../../../managerApp/resources/invoices/InvoiceShow";
import { PrintableInvoiceBlock } from "../../../managerApp/resources/invoices/PrintableInvoiceBlock";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const handleEmailSending = async (emailBody, notify) => {
  // Asynchronous function to handle email sending and conditional invoice update
  try {
    const response = await API.post("transREST", "/sendEmail", {
      body: emailBody,
    });

    if (response.status !== "success") {
      notify("Error occurred while sending email.", "error");
      logError(
        "invoices:InvoiceShow:sendInvoice:handleEmailSending:" + emailBody,
        response,
        false
      );

      throw new Error("Email delivery failed");
    }
    notify("Email sent.", "info");
  } catch (error) {
    logError("invoices:InvoiceShow:sendInvoice", error, false);
  }
};

const sendInvoice = (
  services,
  notify,
  toEmail,
  cc,
  encloseAttachments,
  setSending,
  setEmailOpen,
  props
) => {
  debugger;
  setSending(true);
  const record = props.data;

  let htmlDoc = ReactDOMServer.renderToString(
    <EmailInvoiceBody
      record={record}
      services={services}
      encloseAttachments={encloseAttachments}
      {...props}
    />
  );
  // let prettyHtml = prettier.format(htmlDoc, { parser: "html" });

  const subject = record.poNumber
    ? `Invoice No: ${record.invoiceNumber}, PO No: ${record.poNumber} from ${record.reloadYard.name}`
    : `Invoice No: ${record.invoiceNumber} from ${record.reloadYard.name}`;

  const emailBody = {
    from: "no_reply transloads.co <invoices@transloads.co>",
    to: splitEmails(toEmail),
    cc: cc ? splitEmails(cc) : undefined,
    // bcc: ["support@transloads.co"],
    subject: subject,
    template: "emailTemplateWide.html",
    htmlContent: htmlDoc,
    attachPDF: true,
  };

  // Call the handleEmailSending function without awaiting it
  handleEmailSending(emailBody, notify);
  setEmailOpen(false);
  setSending(false);
};

class PrintableInvoice extends React.PureComponent {
  render() {
    const { record, services, ...props } = this.props;
    return (
      <PrintableInvoiceBlock record={record} services={services} {...props} />
    );
  }
}

const InvoiceActions = ({
  record,
  services,
  backPath,
  invRef,
  notify,
  ...props
}) => {
  const classes = useStyles();
  const [email, setEmail] = useState(
    trimEmail(props.data?.account?.billingEmail)
  );
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [cc, setCC] = useState(
    props.data?.account?.billingContacts
      ? props.data.account.billingContacts
          .map((contact) => contact.email)
          .join(", ")
      : ""
  );
  const [encloseAttachments, setEncloseAttachments] = useState(
    record.account?.invoiceAttachments
  );
  const [emailOpen, setEmailOpen] = useState(false);
  const [sending, setSending] = useState(false);

  const handleEmailChange = (event) => {
    const emailInput = event.target.value;
    setEmail(emailInput);
  };

  const handleEmailBlur = () => {
    setIsEmailValid(validateEmail(email));
  };

  const validateEmail = (email) => {
    if (email) return REGEX_MULTI_EMAIL.test(email.trim());
    return true;
  };

  const handleSubmit = () => {
    const valid = validateEmail(email);
    if (valid) setIsEmailValid(valid);
    else return;

    sendInvoice(
      services,
      notify,
      email,
      cc,
      encloseAttachments,
      setSending,
      setEmailOpen,
      props
    );
  };

  return (
    <TopToolbar>
      <Button
        {...props}
        label="Send"
        color="primary"
        onClick={() => setEmailOpen(true)}
      >
        <EmailIcon />
      </Button>
      <ReactToPrint
        trigger={() => (
          <Button
            {...props}
            label="Print"
            color="primary"
            startIcon={<PrintIcon />}
          />
        )}
        content={() => invRef.current}
        documentTitle={"Transloads_Invoice"}
      />
      <BackButton {...props} backPath={backPath} />
      <Dialog
        open={emailOpen}
        maxWidth="sm"
        onClose={() => setEmailOpen(false)}
        fullWidth
      >
        <DialogTitle>Send Invoice</DialogTitle>
        <DialogContent>
          <Backdrop className={classes.backdrop} open={sending}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <InputField
                label="To email"
                size="small"
                variant="outlined"
                fullWidth
                required
                value={email}
                error={!isEmailValid} // Display error state based on validation
                helperText={
                  !isEmailValid ? "Please enter a valid email address." : false
                }
                onChange={handleEmailChange}
                onBlur={handleEmailBlur}
              />
            </Grid>
            <Grid item xs={12}>
              <InputField
                label="CC"
                size="small"
                variant="outlined"
                fullWidth
                helperText="Comma-separated email(s)"
                value={cc}
                onChange={(event) => setCC(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Switch
                name="enclose-attachments"
                color="primary"
                checked={encloseAttachments}
                onChange={() => setEncloseAttachments(!encloseAttachments)}
              />
              <Typography component="span">Enclose Attachments</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            label="CANCEL"
            color="default"
            onClick={() => setEmailOpen(false)}
          >
            <CancelIcon />
          </Button>
          <Button
            label="SEND"
            color="primary"
            disabled={!email.trim()}
            onClick={handleSubmit}
          >
            <EmailIcon />
          </Button>
        </DialogActions>
      </Dialog>
    </TopToolbar>
  );
};

export const InvoiceShow = (props) => {
  const notify = useNotify();
  const invRef = useRef();
  const isComponentMounted = useRef(true);
  const { record } = useShowController(props);
  const [services, setServices] = useState([]);
  const backPath = getBackPath(props);

  useEffect(() => {
    debugger;
    if (isComponentMounted && record) getServices();
    return () => (isComponentMounted.current = false);
  }, []);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const getServices = async () => {
    try {
      setLoading(true);
      let resp = await API.graphql(
        graphqlOperation(serviceByAccountByStatusByName, {
          accountId: record.accountId,
          statusName: { beginsWith: { status: ServiceStatus.AVAILABLE } },
          sortDirection: "ASC",
        })
      );
      let serviceData = resp.data.serviceByAccountByStatusByName?.items;
      setServices(serviceData);
      debugger;
    } catch (err) {
      setError(true);
      logError("invoices:InvoiceShow:getServices", err, notify);
    }
    setLoading(false);
  };

  if (loading) return <Loading />;
  if (!record || !record.reloadYard || error) return null;
  return (
    <Show
      {...props}
      title=" "
      actions={
        <InvoiceActions
          record={record}
          services={services}
          backPath={backPath}
          invRef={invRef}
          notify={notify}
        />
      }
    >
      <SimpleShowLayout>
        <PrintableInvoice record={record} services={services} ref={invRef} />
      </SimpleShowLayout>
    </Show>
  );
};
